import { ApiClient } from '../../core/services/api.service';
import { getTimestamp } from "../../helpers";
import * as i0 from "@angular/core";
import * as i1 from "../../core/services/api.service";
export class FeatureService {
    constructor(http) {
        this.http = http;
        this.apiSegment = 'preventivi';
    }
    all() {
        return this.http.get(`${this.apiSegment}`);
    }
    create(data) {
        return this.http.post(`${this.apiSegment}`, data);
    }
    item(id) {
        return this.http.get(`${this.apiSegment}/${id}`);
    }
    update(id, data) {
        if (data instanceof FormData) {
            data.append('_method', 'PUT');
        }
        else {
            data = Object.assign({}, data, { '_method': 'PUT' });
        }
        return this.http.post(`${this.apiSegment}/${id}`, data);
    }
    delete(id) {
        return this.http.delete(`${this.apiSegment}/${id}`);
    }
    pdf(id) {
        const timestamp = getTimestamp();
        return this.http.getEndpoint(`${this.apiSegment}/${id}/pdf`, { time: timestamp });
    }
}
FeatureService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function FeatureService_Factory() { return new FeatureService(i0.ɵɵinject(i1.ApiClient)); }, token: FeatureService, providedIn: "root" });
